import { useEffect } from 'react';

import { astrazeneca_settings } from '~implementations/astrazeneca';
import { colsubsidio_settings } from '~implementations/colsubsidio';
import { coomevamp_settings } from '~implementations/coomevamp';
import { coosalud_settings } from '~implementations/coosalud';
import { fci_settings } from '~implementations/fci';
import { horizonte_settings } from '~implementations/horizonte';
import { incans_settings } from '~implementations/incans';
import { khymei_settings } from '~implementations/khymei';
import { rimac_settings } from '~implementations/rimac';
import { salud_total_settings } from '~implementations/saludTotal';
import { sanitas_settings } from '~implementations/sanitas';

const allAppSettings: Record<AppImplementation, ImplementationSettings> = {
  astrazeneca: astrazeneca_settings,
  colsubsidio: colsubsidio_settings,
  colsubsidioTest: colsubsidio_settings,
  coosalud: coosalud_settings,
  coosaludTest: coosalud_settings,
  coomevamp: coomevamp_settings,
  fci: fci_settings,
  fciTest: fci_settings,
  rimac: rimac_settings,
  rimacTest: rimac_settings,
  horizonte: horizonte_settings,
  incans: incans_settings,
  salud_total: salud_total_settings,
  salud_totalTest: salud_total_settings,
  sanitas: sanitas_settings,
  khymei: khymei_settings
};

export type Logos = keyof ImplementationSettings['logos'];
export type Envs = keyof ImplementationSettings['envs'];

export interface AppImplementationConfig {
  name: AppImplementation;
  envs: Record<Envs, string>;
  logos: Record<Logos, string>;
  workUnits: WorkUnit[];
}

const implementation = import.meta.env.VITE_IMPLEMENTATION;
const appSettingsSelected = allAppSettings[implementation];

const useImplementation = () => {
  useEffect(() => {
    const implementationColors = Object.entries(appSettingsSelected.colors);
    implementationColors.map((color) => {
      document.documentElement.style.setProperty(color[0], color[1]);
    });
  }, []);

  return {
    name: implementation,
    ...appSettingsSelected
  };
};

export default useImplementation;
